import React from 'react';
import { HashRouter as Router, Link } from 'react-router-dom';
import { RouteWithSubRoutes } from '../../service/common';

export default function LeftNav({ routes }) {
  // Categorize routes more precisely
  const libraryRoutes = routes.filter(route => 
    !route.category && 
    !route.isApp && 
    !route.displayNone
  );

  const appRoutes = routes.filter(route => 
    route.isApp && 
    !route.displayNone && 
    !route.category
  );

  const userManagementRoutes = routes.filter(route => 
    route.category === 'userManagement' && 
    !route.displayNone
  );

  const firstRoute = libraryRoutes?.length > 0 ? libraryRoutes[0] : '/login';

  return (
    <Router>
      <aside className='main-sidebar'>
        {/* Library Section - only non-App, non-UserManagement routes */}
        {libraryRoutes.length > 0 && (
          <>
            <h5 style={{ color: 'gray', padding: '20px 10px 0px' }}>Library</h5>
            <ul className='sidebar-menu' style={{ marginBottom: '20px' }}>
              {libraryRoutes.map(route => (
                <li key={route.name}>
                  <Link to={route.path}>
                    <i className={route.cssClass || 'fa fa-dashboard'}></i>
                    <span className='menu-text-div'>{route.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}

        {/* App Section - only routes explicitly marked as isApp */}
        {appRoutes.length > 0 && (
          <>
            <h5 style={{ color: 'gray', padding: '20px 10px 0px' }}>App</h5>
            <ul className='sidebar-menu' style={{ marginBottom: '20px' }}>
              {appRoutes.map(route => (
                <li key={route.name}>
                  <Link to={route.path}>
                    <i className={route.cssClass || 'fa fa-dashboard'}></i>
                    <span className='menu-text-div'>{route.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}

        {/* User Management Section */}
        {userManagementRoutes.length > 0 && (
          <>
            <h5 style={{ color: 'gray', padding: '20px 10px 0px' }}>User Management</h5>
            <ul className='sidebar-menu' style={{ marginBottom: '30px' }}>
              {userManagementRoutes.map(route => (
                <li key={route.name}>
                  <Link to={route.path}>
                    <i className={route.cssClass || 'fa fa-dashboard'}></i>
                    <span className='menu-text-div'>{route.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </>
        )}
      </aside>
      <div className='content-wrapper'>
        {routes.map((route) => RouteWithSubRoutes(route, firstRoute))}
      </div>
    </Router>
  );
}